module.exports = __webpack_public_path__ + "img/Snowfall_black.3acdc9d9.png";